import { AlertBlockTypeEnum } from '../enums/alert-block-type.enum';

/**
 * A mapping of blockTypes to its properties and their related generalStyle properties
 */
export const alertBlockToGeneralStyle = new Map<AlertBlockTypeEnum, Map<string, string>>(
    [
        [
            AlertBlockTypeEnum.DATE,
            new Map<string, string>(
                [
                    ['styles.styleState', 'date.styleState'],
                    ['styles.displayStyleState', 'date.displayStyleState'],
                    ['styles.backgroundColor', 'date.backgroundColor'],
                    ['styles.font.alignment', 'date.font.alignment'],
                    ['styles.font.bold', 'date.font.bold'],
                    ['styles.font.italics', 'date.font.italics'],
                    ['styles.font.underlined', 'date.font.underlined'],
                    ['styles.font.color', 'date.font.color'],
                    ['styles.font.fontFamily', 'date.font.fontFamily'],
                    ['styles.font.fontSize', 'date.font.fontSize'],
                    ['styles.dateFormat', 'date.dateFormat']
                ]
            )
        ],
        [
            AlertBlockTypeEnum.TEXT,
            new Map<string, string>(
                [
                    ['styles.styleState', 'text.styleState'],
                    ['styles.displayStyleState', 'text.displayStyleState'],
                    ['styles.color', 'text.color'],
                    ['styles.fontFamily', 'text.fontFamily'],
                    ['styles.fontSize', 'text.fontSize'],
                    ['styles.italics', 'text.italics'],
                    ['styles.underlined', 'text.underlined'],
                    ['styles.bold', 'text.bold'],
                    ['styles.alignment', 'text.alignment']
                ]
            )
        ],
        [
            AlertBlockTypeEnum.TITLE,
            new Map<string, string>(
                [
                    ['styles.styleState', 'title.styleState'],
                    ['styles.displayStyleState', 'title.displayStyleState'],
                    ['styles.color', 'title.color'],
                    ['styles.fontFamily', 'title.fontFamily'],
                    ['styles.fontSize', 'title.fontSize'],
                    ['styles.italics', 'title.italics'],
                    ['styles.underlined', 'title.underlined'],
                    ['styles.bold', 'title.bold'],
                    ['styles.alignment', 'title.alignment'],
                    ['styles.backgroundColor', 'title.backgroundColor'],
                    ['styles.headingTwo.color', 'title.headingTwo.color'],
                    ['styles.headingTwo.fontFamily', 'title.headingTwo.fontFamily'],
                    ['styles.headingTwo.fontSize', 'title.headingTwo.fontSize'],
                    ['styles.headingTwo.bold', 'title.headingTwo.bold'],
                    ['styles.headingTwo.italics', 'title.headingTwo.italics'],
                    ['styles.headingTwo.underlined', 'title.headingTwo.underlined'],
                    ['styles.headingTwo.alignment', 'title.headingTwo.alignment'],
                    ['styles.headingTwo.backgroundColor', 'title.headingTwo.backgroundColor'],
                    ['styles.headingThree.color', 'title.headingThree.color'],
                    ['styles.headingThree.fontFamily', 'title.headingThree.fontFamily'],
                    ['styles.headingThree.fontSize', 'title.headingThree.fontSize'],
                    ['styles.headingThree.bold', 'title.headingThree.bold'],
                    ['styles.headingThree.italics', 'title.headingThree.italics'],
                    ['styles.headingThree.underlined', 'title.headingThree.underlined'],
                    ['styles.headingThree.alignment', 'title.headingThree.alignment'],
                    ['styles.headingThree.backgroundColor', 'title.headingThree.backgroundColor'],
                ]
            )
        ],
        [
            AlertBlockTypeEnum.IMAGE,
            new Map<string, string>(
                [
                    ['styles.styleState', 'image.styleState'],
                    ['styles.displayStyleState', 'image.displayStyleState'],
                    ['styles.color', 'image.color'],
                    ['styles.fontFamily', 'image.fontFamily'],
                    ['styles.fontSize', 'image.fontSize'],
                    ['styles.italics', 'image.italics'],
                    ['styles.underlined', 'image.underlined'],
                    ['styles.bold', 'image.bold'],
                    ['styles.alignment', 'image.alignment'],
                    ['styles.imageAlignment', 'image.imageAlignment'],
                    ['styles.width', 'image.width']
                ]
            )
        ],
        [
            AlertBlockTypeEnum.ALERT_MENTIONS,
            new Map<string, string>(
                [
                    ['styles.styleState', 'mention.styleState'],
                    ['styles.displayStyleState', 'mention.displayStyleState'],
                    ['styles.mentionContent', 'mention.mentionContent'],
                    ['styles.showInsights', 'mention.showInsights'],
                    ['styles.displayInsightsName', 'mention.displayInsightsName'],
                    ['styles.insightsNameDisplay', 'mention.insightsNameDisplay'],
                    ['styles.customInsightsName', 'mention.customInsightsName'],
                    ['styles.mentionInsightsLinkLabel', 'mention.mentionInsightsLinkLabel'],
                    ['styles.metadataTypes', 'mention.metadataTypes'],
                    ['styles.metadataOrder', 'mention.metadataOrder'],
                    ['styles.mediaType', 'mention.mediaType'],
                    ['styles.notes', 'mention.notes'],
                    ['styles.heading.color', 'mention.heading.color'],
                    ['styles.heading.fontFamily', 'mention.heading.fontFamily'],
                    ['styles.heading.fontSize', 'mention.heading.fontSize'],
                    ['styles.heading.bold', 'mention.heading.bold'],
                    ['styles.heading.italics', 'mention.heading.italics'],
                    ['styles.heading.underlined', 'mention.heading.underlined'],
                    ['styles.heading.alignment', 'mention.heading.alignment'],
                    ['styles.sectionHeading.color', 'mention.sectionHeading.color'],
                    ['styles.sectionHeading.fontFamily', 'mention.sectionHeading.fontFamily'],
                    ['styles.sectionHeading.fontSize', 'mention.sectionHeading.fontSize'],
                    ['styles.sectionHeading.bold', 'mention.sectionHeading.bold'],
                    ['styles.sectionHeading.italics', 'mention.sectionHeading.italics'],
                    ['styles.sectionHeading.underlined', 'mention.sectionHeading.underlined'],
                    ['styles.sectionHeading.alignment', 'mention.sectionHeading.alignment'],
                    ['styles.notesFont.color', 'mention.notesFont.color'],
                    ['styles.notesFont.fontFamily', 'mention.notesFont.fontFamily'],
                    ['styles.notesFont.fontSize', 'mention.notesFont.fontSize'],
                    ['styles.notesFont.bold', 'mention.notesFont.bold'],
                    ['styles.notesFont.italics', 'mention.notesFont.italics'],
                    ['styles.notesFont.underlined', 'mention.notesFont.underlined'],
                    ['styles.notesFont.alignment', 'mention.notesFont.alignment'],
                    ['styles.snippetFont.color', 'mention.snippetFont.color'],
                    ['styles.snippetFont.fontFamily', 'mention.snippetFont.fontFamily'],
                    ['styles.snippetFont.fontSize', 'mention.snippetFont.fontSize'],
                    ['styles.snippetFont.bold', 'mention.snippetFont.bold'],
                    ['styles.snippetFont.italics', 'mention.snippetFont.italics'],
                    ['styles.snippetFont.underlined', 'mention.snippetFont.underlined'],
                    ['styles.snippetFont.alignment', 'mention.snippetFont.alignment'],
                    ['styles.insightsFont.color', 'mention.insightsFont.color'],
                    ['styles.insightsFont.fontFamily', 'mention.insightsFont.fontFamily'],
                    ['styles.insightsFont.fontSize', 'mention.insightsFont.fontSize'],
                    ['styles.insightsFont.bold', 'mention.insightsFont.bold'],
                    ['styles.insightsFont.italics', 'mention.insightsFont.italics'],
                    ['styles.insightsFont.underlined', 'mention.insightsFont.underlined'],
                    ['styles.insightsFont.alignment', 'mention.insightsFont.alignment'],
                    ['styles.mentionInsightsLinkFont.color', 'mention.mentionInsightsLinkFont.color'],
                    ['styles.mentionInsightsLinkFont.fontFamily', 'mention.mentionInsightsLinkFont.fontFamily'],
                    ['styles.mentionInsightsLinkFont.fontSize', 'mention.mentionInsightsLinkFont.fontSize'],
                    ['styles.mentionInsightsLinkFont.bold', 'mention.mentionInsightsLinkFont.bold'],
                    ['styles.mentionInsightsLinkFont.italics', 'mention.mentionInsightsLinkFont.italics'],
                    ['styles.mentionInsightsLinkFont.underlined', 'mention.mentionInsightsLinkFont.underlined'],
                    ['styles.metadataFont.color', 'mention.metadataFont.color'],
                    ['styles.metadataFont.fontFamily', 'mention.metadataFont.fontFamily'],
                    ['styles.metadataFont.bold', 'mention.metadataFont.bold'],
                    ['styles.metadataFont.italics', 'mention.metadataFont.italics'],
                    ['styles.metadataFont.underlined', 'mention.metadataFont.underlined'],
                    ['styles.preferredCurrency', 'mention.preferredCurrency'],
                    ['styles.timezone', 'mention.timezone']
                ]
            )
        ],
        [
            AlertBlockTypeEnum.SURGE_ALERT,
            new Map<string, string>(
                [
                    ['styles.styleState', 'text.styleState'],
                    ['styles.displayStyleState', 'text.displayStyleState'],
                    ['styles.color', 'text.color'],
                    ['styles.fontFamily', 'text.fontFamily'],
                    ['styles.fontSize', 'text.fontSize'],
                    ['styles.italics', 'text.italics'],
                    ['styles.underlined', 'text.underlined'],
                    ['styles.bold', 'text.bold'],
                    ['styles.alignment', 'text.alignment']
                ]
            )
        ],
        [
            AlertBlockTypeEnum.AUTOMATIC_MENTION_LIST,
            new Map<string, string>(
                [
                    ['styles.styleState', 'mention.styleState'],
                    ['styles.displayStyleState', 'mention.displayStyleState'],
                    ['styles.mentionContent', 'mention.mentionContent'],
                    ['styles.showInsights', 'mention.showInsights'],
                    ['styles.displayInsightsName', 'mention.displayInsightsName'],
                    ['styles.insightsNameDisplay', 'mention.insightsNameDisplay'],
                    ['styles.customInsightsName', 'mention.customInsightsName'],
                    ['styles.mentionInsightsLinkLabel', 'mention.mentionInsightsLinkLabel'],
                    ['styles.metadataTypes', 'mention.metadataTypes'],
                    ['styles.metadataOrder', 'mention.metadataOrder'],
                    ['styles.mediaType', 'mention.mediaType'],
                    ['styles.notes', 'mention.notes'],
                    ['styles.heading.color', 'mention.heading.color'],
                    ['styles.heading.fontFamily', 'mention.heading.fontFamily'],
                    ['styles.heading.fontSize', 'mention.heading.fontSize'],
                    ['styles.heading.bold', 'mention.heading.bold'],
                    ['styles.heading.italics', 'mention.heading.italics'],
                    ['styles.heading.underlined', 'mention.heading.underlined'],
                    ['styles.heading.alignment', 'mention.heading.alignment'],
                    ['styles.sectionHeading.color', 'mention.sectionHeading.color'],
                    ['styles.sectionHeading.fontFamily', 'mention.sectionHeading.fontFamily'],
                    ['styles.sectionHeading.fontSize', 'mention.sectionHeading.fontSize'],
                    ['styles.sectionHeading.bold', 'mention.sectionHeading.bold'],
                    ['styles.sectionHeading.italics', 'mention.sectionHeading.italics'],
                    ['styles.sectionHeading.underlined', 'mention.sectionHeading.underlined'],
                    ['styles.sectionHeading.alignment', 'mention.sectionHeading.alignment'],
                ]
            )
        ],
        [
            AlertBlockTypeEnum.ONE_COLUMN_LAYOUT,
            new Map<string, string>(
                [
                    ['styles.styleState', 'oneColumnLayout.styleState'],
                    ['styles.displayStyleState', 'oneColumnLayout.displayStyleState'],
                    ['styles.backgroundColor', 'oneColumnLayout.backgroundColor'],
                    ['styles.padding', 'oneColumnLayout.padding'],
                    ['styles.width', 'oneColumnLayout.width'],
                    ['styles.cornerRadius', 'oneColumnLayout.cornerRadius']
                ]
            )
        ],
        [
            AlertBlockTypeEnum.TWO_COLUMN_LAYOUT,
            new Map<string, string>(
                [
                    ['styles.styleState', 'twoColumnLayout.styleState'],
                    ['styles.displayStyleState', 'twoColumnLayout.displayStyleState'],
                    ['styles.displayRatio', 'twoColumnLayout.displayRatio'],
                    ['styles.width', 'twoColumnLayout.width'],
                    ['styles.backgroundColor', 'twoColumnLayout.backgroundColor'],
                    ['styles.verticalAlignment', 'twoColumnLayout.verticalAlignment'],
                    ['styles.padding', 'twoColumnLayout.padding'],
                    ['styles.columnSpacing', 'twoColumnLayout.columnSpacing'],
                    ['styles.cornerRadius', 'twoColumnLayout.cornerRadius']
                ]
            )
        ],
        [
            AlertBlockTypeEnum.THREE_COLUMN_LAYOUT,
            new Map<string, string>(
                [
                    ['styles.styleState', 'threeColumnLayout.styleState'],
                    ['styles.displayStyleState', 'threeColumnLayout.displayStyleState'],
                    ['styles.displayRatio', 'threeColumnLayout.displayRatio'],
                    ['styles.width', 'threeColumnLayout.width'],
                    ['styles.backgroundColor', 'threeColumnLayout.backgroundColor'],
                    ['styles.verticalAlignment', 'threeColumnLayout.verticalAlignment'],
                    ['styles.padding', 'threeColumnLayout.padding'],
                    ['styles.columnSpacing', 'threeColumnLayout.columnSpacing'],
                    ['styles.cornerRadius', 'threeColumnLayout.cornerRadius']
                ]
            )
        ],
        [
            AlertBlockTypeEnum.ANALYSIS,
            new Map<string, string>(
                [
                    ['styles.styleState', 'analysis.styleState'],
                    ['styles.displayStyleState', 'analysis.displayStyleState'],
                    ['styles.color', 'analysis.color'],
                    ['styles.backgroundColor', 'analysis.backgroundColor'],
                    ['styles.fontFamily', 'analysis.fontFamily'],
                    ['styles.fontSize', 'analysis.fontSize'],
                    ['styles.italics', 'analysis.italics'],
                    ['styles.underlined', 'analysis.underlined'],
                    ['styles.bold', 'analysis.bold'],
                    ['styles.alignment', 'analysis.alignment'],
                    ['styles.padding', 'analysis.padding']
                ]
            )
        ],
        [
            AlertBlockTypeEnum.DIVIDER,
            new Map<string, string>(
                [
                    ['styles.styleState', 'divider.styleState'],
                    ['styles.displayStyleState', 'divider.displayStyleState'],
                    ['styles.dividerColor', 'divider.dividerColor'],
                    ['styles.defaultReference', 'divider.defaultReference'],
                    ['styles.height', 'divider.height'],
                    ['styles.marginBottom', 'divider.marginBottom'],
                    ['styles.marginTop', 'divider.marginTop'],
                    ['styles.backgroundColor', 'divider.backgroundColor'],
                    ['styles.padding', 'divider.padding']
                ]
            )
        ],
        [
            AlertBlockTypeEnum.CHART,
            new Map<string, string>(
                [
                    ['styles.styleState', 'chart.styleState'],
                    ['styles.displayStyleState', 'chart.displayStyleState'],
                    ['styles.color', 'chart.color'],
                    ['styles.backgroundColor', 'chart.backgroundColor'],
                    ['styles.fontFamily', 'chart.fontFamily'],
                    ['styles.fontSize', 'chart.fontSize'],
                    ['styles.italics', 'chart.italics'],
                    ['styles.underlined', 'chart.underlined'],
                    ['styles.bold', 'chart.bold'],
                    ['styles.alignment', 'chart.alignment'],
                    ['styles.imageAlignment', 'chart.imageAlignment'],
                    ['styles.width', 'chart.width'],
                    ['styles.doBorder', 'chart.doBorder'],
                    ['styles.borderWidth', 'chart.borderWidth'],
                    ['styles.borderColor', 'chart.borderColor'],
                    ['styles.padding', 'chart.padding'],
                    ['styles.cornerRadius', 'chart.cornerRadius']
                ]
            )
        ],
        [
            AlertBlockTypeEnum.COVERAGE_CURATOR,
            new Map<string, string>(
                [
                    ['styles.styleState', 'coverageCurator.styleState'],
                    ['styles.displayStyleState', 'coverageCurator.displayStyleState'],
                    ['styles.backgroundColor', 'coverageCurator.backgroundColor'],
                    ['styles.padding', 'coverageCurator.padding']
                ]
            )
        ],
    ]
);

/**
 * Returns a mapping of properties on the generalStyle object to the related block types and the block type properties
 *
 * @param alertBlockToGeneralStyle: A mapping of blockTypes to its properties and their related generalStyle properties
 *
 * @returns Map<string, Map<AlertBlockTypeEnum, string>>
 */
const generalStyleToAlertBlockHelper = (
    alertBlockToGeneralStyleProperty: Map<AlertBlockTypeEnum, Map<string, string>>

): Map<string, Map<AlertBlockTypeEnum, string>> => {

    const generalStylesToAlertBlockPropertyMap = new Map<string, Map<AlertBlockTypeEnum, string>>();

    alertBlockToGeneralStyle.forEach((generalStylesToBlockPropertyMap, blockType) => {
        generalStylesToBlockPropertyMap.forEach((generalStylesProperty, blockProperty) => {

            // mapping of block type to one of its properties in the context of a generalStylesProperty
            let blockTypeBlockPropertyMap = generalStylesToAlertBlockPropertyMap.get(generalStylesProperty);

            if (blockTypeBlockPropertyMap) {
                blockTypeBlockPropertyMap.set(blockType, blockProperty);
            } else {
                blockTypeBlockPropertyMap = new Map<AlertBlockTypeEnum, string>();
                blockTypeBlockPropertyMap.set(blockType, blockProperty);
                generalStylesToAlertBlockPropertyMap.set(generalStylesProperty, blockTypeBlockPropertyMap);
            }
        });
    });

    return generalStylesToAlertBlockPropertyMap;
};

/**
 * A mapping of properties on the generalStyle object to the related block types and the block type properties
 */
export const generalStyleToAlertBlockMap = generalStyleToAlertBlockHelper(alertBlockToGeneralStyle);

const getBlockTypeToGeneralStylesTopLevelProperty = (): Map<any, any>[] => {
    const blockTypeToGeneralStylesTopLevelPropertyMap: Map<AlertBlockTypeEnum, string> = new Map();
    const generalStylesTopLevelPropertyToAlertBlockTypeMap: Map<string, AlertBlockTypeEnum> = new Map();

    alertBlockToGeneralStyle.forEach((blockToGeneralMap, blockType) => {
        const generalStylePropertyString = blockToGeneralMap.values().next().value;
        if (!generalStylePropertyString) {
            return;
        }

        const generalStyleTopLevelProperty = generalStylePropertyString.split('.')[0];

        blockTypeToGeneralStylesTopLevelPropertyMap.set(blockType, generalStyleTopLevelProperty);
        generalStylesTopLevelPropertyToAlertBlockTypeMap.set(generalStyleTopLevelProperty, blockType);
    });

    return [blockTypeToGeneralStylesTopLevelPropertyMap, generalStylesTopLevelPropertyToAlertBlockTypeMap];
};

/**
 * A mapping of block types to the specific property on generalStylesModel
 */
export const alertBlockTypeToGeneralStylesPropertyMap: Map<AlertBlockTypeEnum, string> = getBlockTypeToGeneralStylesTopLevelProperty()[0];

/**
 * A mapping of generalStylesModels to alert block types
 */
export const generalStylesPropertyToAlertBlock: Map<string, AlertBlockTypeEnum> = getBlockTypeToGeneralStylesTopLevelProperty()[1];
